export default {
  link: [
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/icons/apple-touch-icon.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: '/icons/favicon-32x32.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: '/icons/favicon-16x16.png',
    },
    {
      rel: 'mask-icon',
      href: '/icons/safari-pinned-tab.svg',
      color: '#5bbad5',
    },
    { rel: 'shortcut icon', href: '/icons/favicon.ico' },
  ],
  meta: [
    { name: 'msapplication-TileColor', content: '#ffffff' },
    {
      name: 'msapplication-TileImage',
      content: '/icons/mstile-144x144.png',
    },
    { name: 'msapplication-config', content: '/icons/browserconfig.xml' },
    { name: 'theme-color', content: '#ffffff' },
  ],
} as const;
